import React from 'react';
import StreetSelectionForm from '../../components/User/Profile/StreetSelectionForm';

export default function StreetSelection() {
  return (
    <div className="container container__wrap street-selection col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
      <div className="row d-flex justify-content-center">
        <StreetSelectionForm />
      </div>
    </div>
  );
}
